export default "__VITE_ASSET__CWmb3wW2__"